import { Form, message } from "antd";
import { useState } from "react";
import {fetchSubmit} from '../../../../../../api/pages/easyDeployApi';
const ContactModelHooks = () => {
    const [form] = Form.useForm();
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [btnLoading, setBtnLoading] = useState<boolean>(false);

    const onFinish = async(values: any) => {
        setBtnLoading(true);
        const res = await fetchSubmit({
            model_type: form.getFieldValue("model_type"),
            model_name: form.getFieldValue("model_name"),
            deployment_of_chip: form.getFieldValue("deployment_of_chip"),
            phone: form.getFieldValue("phone"),
            demand_desc:form.getFieldValue("demand_desc"),
           
        });
        if(res.status === 200) {
            message.success("提交成功");
            setIsModalVisible(false);
            setBtnLoading(false);
            form.resetFields();
        }else {
            setBtnLoading(false);
        };
      };
    const showModal = () => {
        setIsModalVisible(true);
     
    };

    const handleOk = () => {
        setIsModalVisible(false);
       
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };
    return (
        {
            isModalVisible,
            setIsModalVisible,
            showModal,
            handleOk,
            handleCancel,
            onFinish,
            form,
            btnLoading
           
        }
    )
}

export default ContactModelHooks;